// frontend/src/routes/AppRoutes.jsx
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

// Páginas de dashboard
import Dashboard from '../pages/dashboard/Dashboard';

// Pacientes
import PacientesList from '../pages/pacientes/PacientesList';
import PacienteCreate from '../pages/pacientes/PacienteCreate';
import PacienteDetail from '../pages/pacientes/PacienteDetail';
import PacienteEdit from '../pages/pacientes/PacienteEdit';

// Historias Clínicas
import HistoriasList from '../pages/historias/HistoriasList';
import HistoriaDetail from '../pages/historias/HistoriaDetail';
import HistoriaCreate from '../pages/historias/HistoriaCreate';
import HistoriaEdit from '../pages/historias/HistoriaEdit';
import PrintHistoria from '../pages/historias/PrintHistoria';
import SesionList from '../pages/historias/SesionList';
import VistaHCE from '../pages/historias/VistaHCE';

// Citas
import CitasList from '../pages/citas/CitasList';
import CitaCalendar from '../pages/citas/CitaCalendar';
import CitaCreate from '../pages/citas/CitaCreate';
import CitaEdit from '../pages/citas/CitaEdit';
import CitaDetail from '../pages/citas/CitaDetail';

// Especialistas
import EspecialistasList from '../pages/especialistas/EspecialistasList';
import EspecialistaDetail from '../pages/especialistas/EspecialistaDetail';
import EspecialistaCreate from '../pages/especialistas/EspecialistaCreate';
import EspecialistaEdit from '../pages/especialistas/EspecialistaEdit';

// Configuración
import ConfiguracionGeneral from '../pages/configuracion/ConfiguracionGeneral';
import UsuariosList from '../pages/configuracion/UsuariosList';
import Especialidades from '../pages/configuracion/Especialidades';
import ProgramasList from '../pages/configuracion/ProgramasList';
import PlantillasMensajes from '../pages/configuracion/PlantillasMensajes';
import EtapasTratamiento from '../pages/configuracion/EtapasTratamiento';
import AdministrarFormularios from '../pages/configuracion/AdministrarFormularios';
import Membretes from '../pages/configuracion/Membretes';
import AsociacionInternos from '../pages/configuracion/AsignacionInternos';

import GestionDocumentosEtapa from '../pages/configuracion/GestionDocumentosEtapa';
import FormularioPdfEditor from '../components/formularios/FormularioPdfEditor';
import GestionFormulariosEtapa from '../pages/configuracion/GestionFormulariosEtapa';
import AsociarPlantillasEtapas from '../pages/configuracion/AsociarPlantillasEtapas';
import AsignacionInternos from '../pages/configuracion/AsignacionInternos';

// Reportes
import ReportesList from '../pages/reportes/ReportesList';
import ReportesView from '../pages/reportes/ReportesView';

// Perfil
import Perfil from '../pages/perfil/Perfil';

// Páginas de error
import NotFound from '../pages/errors/NotFound';
import Forbidden from '../pages/errors/Forbidden';
import ServerError from '../pages/errors/ServerError';

// Componentes de formularios
import FormularioEditor from '../components/formularios/FormularioEditor';
import FormularioPdfManager from '../components/formularios/FormularioPdfManager';
import FormularioPdfViewer from '../components/formularios/FormularioPdfViewer';

// Componentes de plantillas
import EditorPlantillaAvanzado from '../components/plantillas/EditorPlantillaAvanzado';

// Layout para impresión
import PrintLayout from '../components/layout/PrintLayout';
import RecursosMateriales from '../pages/recursos/RecursosMateriales';

import FormularioDependiente from '../components/formularios/FormularioDependiente';
import FormulariosDependientesPage from '../pages/historias/FormulariosDependientesPage';
import ProgresoFormulario from '../pages/historias/ProgresoFormulario';
//import SelectorPlanTerapeutico from '../components/formularios/SelectorPlanTerapeutico';

// Auditoría
import AuditoriaList from '../pages/auditoria/AuditoriaList';

// Componente de protección de rutas
import ProtectedRoute from '../components/common/ProtectedRoute';

const AppRoutes = () => {
  return (
    <Routes>
      {/* Dashboard */}
      <Route path="/dashboard" element={<Dashboard />} />
      
      {/* Pacientes */}
      <Route path="/pacientes" element={<PacientesList />} />
      <Route path="/pacientes/:id" element={<PacienteDetail />} />
      <Route path="/pacientes/nuevo" element={<PacienteCreate />} />
      <Route path="/pacientes/editar/:id" element={<PacienteEdit />} />
      
       {/* Especialistas */}
      <Route path="/especialistas" element={<EspecialistasList />} />
      <Route path="/especialistas/:id" element={<EspecialistaDetail />} />
      <Route path="/especialistas/nuevo" element={<EspecialistaCreate />} />
      <Route path="/especialistas/editar/:id" element={<EspecialistaEdit />} />

      {/* Citas */}
      <Route path="/citas" element={<CitasList />} />
      <Route path="/citas/:id" element={<CitaDetail />} />
      <Route path="/citas/nueva" element={<CitaCreate />} />
      <Route path="/citas/calendario" element={<CitaCalendar />} />
      <Route path="/citas/editar/:id" element={<CitaEdit />} />

      {/* Historias Clínicas */}
      <Route path="/historias" element={<HistoriasList />} />
      <Route path="/historias/nueva" element={<HistoriaCreate />} />
      <Route path="/historias/:id" element={<HistoriaDetail />} />
      <Route path="/historias/editar/:id" element={<HistoriaEdit />} />
      <Route path="/historias/imprimir/:id" element={<PrintHistoria />} />
      <Route path="/historias/sesiones/:historiaId" element={<SesionList />} />
      <Route path="/hce/:pacienteId" element={<VistaHCE />} />
      
      {/* Auditoría - Solo administradores */}
      <Route 
        path="/auditoria" 
        element={
          <ProtectedRoute requiredRoles={['Administrador']}>
            <AuditoriaList />
          </ProtectedRoute>
        } 
      />

        {/* Reportes */}
      <Route path="/reportes" element={<ReportesList />} />
      <Route path="/reportes/:id" element={<ReportesView />} />
      
      <Route path="/recursos-materiales" element={<RecursosMateriales />} />
      {/* Configuración */}
      <Route path="/configuracion" element={<ConfiguracionGeneral />} />
      <Route path="/configuracion/usuarios" element={<UsuariosList />} />
      <Route path="/configuracion/especialidades" element={<Especialidades />} />
      <Route path="/configuracion/programas" element={<ProgramasList />} />
      <Route path="/configuracion/plantillas-mensajes" element={<PlantillasMensajes />} />
      <Route path="/configuracion/etapas-tratamiento" element={<EtapasTratamiento />} />
      <Route path="/configuracion/membretes" element={<Membretes />} />
      <Route path="/configuracion/formularios" element={<AdministrarFormularios />} />
      <Route path="/configuracion/formularios/:id/editor" element={<FormularioEditor />} />
      <Route path="/configuracion/formularios/:id/pdf" element={<FormularioPdfManager />} />
      <Route path="/configuracion/asignacion-internos" element={<AsociacionInternos />} />
  
      {/* Formularios */}
      <Route path="/historias/:historiaId/formularios/:formularioId" element={<FormularioEditor />} />
      <Route path="/historias/:historiaId/formularios/:formularioId/editar" element={<FormularioEditor />} />
      <Route path="/formularios/preview/:formularioId" element={<FormularioEditor />} />
      <Route path="/formularios/:formularioId/respuesta/:respuestaId/pdf" element={<FormularioPdfViewer />} />
      
      {/* Rutas para formularios con dependencias */}
      {/* Rutas para formularios con dependencias */}
      <Route 
        path="/formularios/:formularioId/completar/:historiaId" 
        element={<FormularioEditor />} 
      />

      {/* Ruta específica para formularios dependientes */}
      <Route 
        path="/formulario-dependiente/:formularioId/:historiaId/:parentId" 
        element={<FormularioDependiente />} 
      />

      {/* Página de gestión de planes y seguimientos */}
      <Route 
        path="/historia/:historiaId/formularios-terapeuticos" 
        element={<FormulariosDependientesPage />} 
      />

      {/* Vista de progreso de un plan terapéutico */}
      <Route 
        path="/formularios/progreso/:parentRespuestaId" 
        element={<ProgresoFormulario />} 
      />

      {/* Selector de nuevo plan terapéutico
      <Route 
        path="/formularios/nuevo/plan/:historiaId/:especialidadId" 
        element={<SelectorPlanTerapeutico />} 
      /> */}
      {/* Plantillas avanzadas */}
      <Route path="/configuracion/plantillas/:id/editor" element={<EditorPlantillaAvanzado />} />
      
    
      {/* Perfil */}
      <Route path="/perfil" element={<Perfil />} />
      
      {/* Páginas de error */}
      <Route path="/404" element={<NotFound />} />
      <Route path="/403" element={<Forbidden />} />
      <Route path="/500" element={<ServerError />} />
      
      {/* Redirección por defecto */}
      <Route path="/" element={<Navigate to="/dashboard" replace />} />
      <Route path="*" element={<Navigate to="/404" replace />} />
    </Routes>
  );
};

export default AppRoutes;